// extracted by mini-css-extract-plugin
module.exports = {"rotate__wrapper":"rotate_rotate__wrapper__1ft1U","rotateInfo":"rotate_rotateInfo__1NONT"};